import config from "../config";

/**
 * Fetch all orders with optional filters
 * @param {Object} filters - Query parameters for filtering orders
 * @returns {Promise<Object[]>} - List of orders
 */
export const fetchOrders = async (filters = {}) => {
  const query = new URLSearchParams(filters).toString();
  const response = await fetch(`${config.apiUrl}/orders/search/param=?&${query}`);

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

/**
 * Fetch a single order by ID
 * @param {number} orderId - Order ID
 * @returns {Promise<Object>} - Order details
 */
export const fetchOrderById = async (orderId) => {
  const response = await fetch(`${config.apiUrl}/orders/${orderId}`);

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

/**
 * Create a new order
 * @param {Object} orderData - Order details including client_id, branch_id, shipping_address, and items
 * @returns {Promise<Object>} - Created order
 */
export const createOrder = async (orderData) => {
  const response = await fetch(`${config.apiUrl}/orders/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(orderData),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

/**
 * Update an order's status
 * @param {Object} orderData - Object containing order_id and new status
 * @returns {Promise<Object>} - Updated order
 */
export const updateOrderStatus = async (orderData) => {
  const response = await fetch(`${config.apiUrl}/orders/${orderData.order_id}/status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(orderData),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }

  return response.json();
};

/**
 * Delete an order
 * @param {Object} orderData - Object containing order_id
 * @returns {Promise<Object>} - Deletion response
 */
export const deleteOrder = async (orderData) => {
  const response = await fetch(`${config.apiUrl}/orders/${orderData.order_id}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(orderData),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};
